import * as yup from 'yup'
import { DATE_INVALID_SHORT, TYPE_REQUIRED } from 'constants/errors'
import * as moment from 'moment'
import { currencySchemaZeroProhibited, baseDateSchema } from 'helpers/schemaHelpers'

const dateSchema = baseDateSchema
  .typeError(DATE_INVALID_SHORT)
  .max(moment().toDate(), DATE_INVALID_SHORT)
  .required(TYPE_REQUIRED)

export default yup.object().shape({
  date: dateSchema,
  amount: currencySchemaZeroProhibited,
})
